import FitbStep from "./FitbStep";
import MatchingStep from "./MatchingStep";
import MultipleChoiceStep from "./MultipleChoiceStep";
import { CourseTabComponentProps } from "@vixi/types";
import { CourseData } from "@vixi/types";
import { STEP_TYPE } from "@vixi/types";

export type QuestionStepProps = CourseTabComponentProps & CourseData.Step;

/**
 * QuestionStep - A component for displaying a question-type step in the course editor
 * @param props.path ["chapters", index, "lessons", index, "conversations", index, "questions", subIndex]
 */
export function QuestionStep({ id, path, ...props }: QuestionStepProps) {
  const sharedProps = { id, path };

  switch (props?.type) {
    case STEP_TYPE.MCQ:
      return (
        <MultipleChoiceStep {...(props as CourseData.McqStep).multipleChoice} {...sharedProps} />
      );
    case STEP_TYPE.FITB:
      return <FitbStep {...(props as CourseData.FitbStep).fillInTheBlank} {...sharedProps} />;
    case STEP_TYPE.MATCHING:
      return <MatchingStep {...(props as CourseData.MatchingStep).matching} {...sharedProps} />;
    // case STEP_TYPE.TOF:
    //   return <TofStep {...props} path={path} />;
    default:
      return (
        <h4 className="text-error">
          QuestionStep: Invalid question type ({JSON.stringify(props)})
        </h4>
      );
  }
}

export default QuestionStep;
